import { NbDialogRef } from '@nebular/theme';
import {Component, OnDestroy, OnInit} from '@angular/core';
import { ManagementFacade } from '../../../main/modules/management/facade/management.facade';
import {WorkSpaceService} from '../../services/work-space.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'morva-work-space-dialog',
  templateUrl: './work-space-dialog.component.html',
  styleUrls: ['./work-space-dialog.component.scss'],
})
export class WorkSpaceDialogComponent implements OnInit, OnDestroy {
  type: string;
  workSpaceName = '';
  totalPage = 1;
  roles: any[]= null;
  filteredRoles = [];
  isUpdating = false;
  subscription: Subscription;

  constructor(protected dialogRef: NbDialogRef<any>,
    private managementFacade: ManagementFacade,private workspaceService: WorkSpaceService) { }

  ngOnInit(): void {
    this.managementFacade.loadRoles();
    this.setSubscribers();
  }
  setSubscribers() {
    this.subscription = this.managementFacade.getRoles$().subscribe(roles => {
      roles.forEach(role => role['isActive'] = false);
      this.roles = roles;
      this.filteredRoles = roles;
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  createWorkSapce() {
    this.isUpdating = true;
    const workspace = {
      name: this.workSpaceName,
      roles: this.filterRoles(),
    };
    switch (this.type) {
      case 'home':
        this.workspaceService.createHomeWorkSpace(workspace,this.dialogRef);
        break;
      case 'workspace':
        this.managementFacade.createWorkSpace(workspace,this.dialogRef);

    }
  }
  filterRoles() {
    const result = [];
    this.roles.forEach(role => {
      if(role.isActive) {
        result.push(role.id);
      }
    });
    return result;
  }

  searchRoles(key: string): void {
    if (key === '') {
      this.filteredRoles = this.roles;
    } else {
      const result = [];
      this.roles.forEach((role) => {
        if (role.name.toLowerCase().includes(key.toLowerCase())) {
          result.push(role);
        }
      });
      this.filteredRoles = result;
    }
  }

  changeRoleStatus(id: any) {
    this.roles.find(role => role.id === id).isActive = !this.roles.find(role => role.id === id).isActive;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
